var Reverb = window.Reverb || {};

Reverb.RemoteCheckbox = (function () {
  var checkboxes = '[data-ajax-checkbox]';
  var doneEvent = 'reverb:remote-checkbox:done';

  function init() {
    handleRemoteCheckboxes();
  }

  function handleRemoteCheckboxes() {
    $(document).on('click', checkboxes, function (e) {
      submit($(this));
    });
  }

  function submit($checkbox, options) {
    options = options || {};
    options.url = options.url || $checkbox.data('url');

    var method = $checkbox.is(':checked') ? 'post' : 'delete';

    $.ajax({
      type: method,
      url: options.url
    }).done(function () {
      $checkbox.trigger(doneEvent);
      if (options.done) { options.done.call($checkbox); }
      $checkbox.parent('label').highlight();
    });
  }

  return {
    init: init,
    submit: submit
  };
})();

$(Reverb.RemoteCheckbox.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/remote_checkbox.js